import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page17() {
  useEffect(() => {
    document.title = "Маяк — Страница 16"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page15" />
        <ForwardLink href="/page17" />
      </div>

      <p style={{ textAlign: "right" }}>16.</p>
      <p>Лязг.</p>
      <br/>
      <p>ВНУТРИ. МАЯК. МАШИННОЕ ОТДЕЛЕНИЕ – ДЕНЬ</p>
      <p>
        Наконец, МОЛОДОЙ достигает верхней части лестницы. Бочка с маслом<br/>
        ПАДАЕТ на пол. Его мышцы дрожат, капает пот.
      </p>
      <p>Он смотрит вверх, на люк в ФОНАРНОЕ ОТДЕЛЕНИЕ...</p>
      <p>Его тянет туда... <i>что там?</i></p>
      <p>Медленно, он тянется к ручке...</p>
      <p>Толкает...</p>
      <p>Закрыто. Заело. <i>Заперто?</i></p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        Тебе нельзя сюда входить!
      </p>
      <p>СТАРИК пугает МОЛОДОГО. <i>Откуда он взялся?</i></p>
      <p>
        СТАРИК выходит из тени: идет-хромая, хромает, <br/>
        хромает.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Масло, сэр.
      </p>
      <p>Говорит МОЛОДОЙ, чувствуя себя пойманным.</p>
      <p>
        Он отходит от бочки, показывая ее старику,<br/>
        пытаясь скрыть капельку гордости. Он вытирает пот<br/>
        со лба, тяжело дыша.
      </p>
      <p>СТАРИК хромает вокруг него, куря свою трубку.</p>
      <p>ОН ПУСКАЕТ ДЫМ В ЛИЦО МОЛОДОГО. МОЛОДОЙ закрывает глаза.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Устал?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр.
      </p>
      <p>Говорит МОЛОДОЙ, продолжая тяжело дышать.</p>
      <p>
        СТАРИК швыряет в него маленькую, пустую<br/>
        ТРЕХ-ГАЛЛОННУЮ МЕДНУЮ КАНИСТРУ ДЛЯ МАСЛА.
      </p>
      <p>МОЛОДОЙ неловко ЛОВИТ ее.</p>
      <p style={{ textAlign: "right" }}>16.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page15" />
        <ForwardLink href="/page17" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708111114/the-lighthouse-script/iny7ccmmqe6yboqct2mh.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page17;
